import DocumentAccordion from "@root/modules/DocumentsPage/DocumentAccordion";
import ViewDocument from "@modules/DocumentsPage/ViewDocument";
import ShareDocument from "@modules/DocumentsPage/ShareDocument";
new DocumentAccordion();
new ViewDocument();
new ShareDocument();
